import React, { useEffect } from 'react';
import {Divider, Typography} from '@mui/material';

import Container from '../../components/Container';
import Main from '../../layouts/Main';
import GettingStarted from './components/GettingStarted';
import FeaturedForms from './components/FeaturedForms';
import FeaturedServices from './components/FeaturedServices';
import DisplayClerkCheckin from './components/DisplayClerkCheckIn';
import ElectionSchedulesCalculator from './components/ElectionSchedulesCalculator';
import PageBreadCrumbs from '../../components/PageBreadcrumbs';
import MunicipalGuideList from './components/MunicipalGuideList';


const Municipal = (): JSX.Element => {
  
  useEffect(() => {
    document.title = 'OCPF - Municipal Clerk Support';
    const hash = window.location.hash.slice(1); // Remove the '#' character from the hash
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            paddingBottom={2}
            >
            Municipal Clerk Support
        </Typography>
        <Divider />
        <FeaturedServices></FeaturedServices>
        <Divider />
        <FeaturedForms></FeaturedForms>
        <section id="getting-started">
          <Divider />
        </section>
        <GettingStarted></GettingStarted>
        <section id="election-calculator">
          <Divider />
        </section>
        <ElectionSchedulesCalculator></ElectionSchedulesCalculator>
        <section id="municipal-guides">
          <Divider />
        </section>
        <MunicipalGuideList></MunicipalGuideList>
        <Divider />
        <DisplayClerkCheckin></DisplayClerkCheckin>
      </Container>
    </Main>
  );
};

export default Municipal;
